export default __webpack_public_path__ + "static/media/ac_tc3.1629ea60.bmp";